import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface SnackbarState {
  openSnackbar: boolean;
  snackbarErrorStatus?: number;
  snackbarDescription?: string;
  children?: JSX.Element | undefined;
}

const initialState: SnackbarState = {
  openSnackbar: false,
  snackbarErrorStatus: 0,
  snackbarDescription: "",
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setOpenSnackbar: (state, action: PayloadAction<boolean>) => {
      state.openSnackbar = action.payload;
    },
    setSnackbarErrorStatus: (state, action: PayloadAction<number>) => {
      state.snackbarErrorStatus = action.payload;
    },
    setSnackbarDescription: (state, action: PayloadAction<string>) => {
      state.snackbarDescription = action.payload;
    },
    setSnackbarChildren: (
      state,
      action: PayloadAction<JSX.Element | undefined>
    ) => {
      state.children = action.payload;
    },
  },
});

export const getSnackbarState = (state: RootState) => state.snackbar;
export const {
  setOpenSnackbar,
  setSnackbarErrorStatus,
  setSnackbarDescription,
  setSnackbarChildren,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
